const Data = [
  {
    heading: 'Photo Identity',
    subHeading: 'Below are the upload guidelines for Photo Identity',
    card: [
      {
        title: '',
        correctImg: 'PhotoIdentityCorrect',
        wrongImg: 'PhotoIdentityWrong',
        tips: ['Ensure your photo in the document is clear.'],
      },
    ],
  },
  {
    heading: 'PAN Card',
    subHeading: 'Below are the upload guidelines for PAN Card',
    card: [
      {
        title: 'front',
        docType: 'PAN Card',
        correctImg: 'PanFrontCorrect',
        wrongImg: 'PanFrontWrong',
        tips: [
          'Ensure the PAN number is clear and readable.',
          'Ensure your photo in the document is clear.',
        ],
      },
    ],
  },
  {
    heading: 'Aadhaar Card',
    subHeading: 'Below are the upload guidelines for Aadhaar front & back',
    card: [
      {
        title: 'front',
        docType: 'Aadhaar Card',
        correctImg: 'AadhaarFrontCorrect',
        wrongImg: 'AadhaarFrontWrong',
        tips: [
          'Capture the front side of the Aadhaar Card.',
          'Mask the first 8 digits with a tape or paper and capture a photo.',
          'Ensure your photo in the document is clear.',
        ],
      },
      {
        title: 'back',
        docType: 'Aadhaar Card',
        correctImg: 'AadhaarBackCorrect',
        wrongImg: 'AadhaarBackWrong',
        tips: [
          'Capture the back side of the Aadhaar Card.',
          'Mask the first 8 digits with a tape or paper and capture a photo.',
          'Ensure address in the document is clear and readable.',
        ],
      },
    ],
  },
  {
    heading: 'Passport',
    subHeading: 'Below are the upload guidelines for Passport front & back',
    card: [
      {
        title: 'front',
        docType: 'Passport',
        correctImg: 'PassportFrontCorrect',
        wrongImg: 'PassportFrontWrong',
        tips: [
          'Capture the front side of the Passport.',
          'Ensure your photo in the document is clear.',
          'Validity should be more than 1 month as on today.',
        ],
      },
      {
        title: 'back',
        docType: 'Passport',
        correctImg: 'PassportBackCorrect',
        wrongImg: 'PassportBackWrong',
        tips: [
          'Capture the back side of the passport.',
          'Ensure address in the document is clear and readable.',
          'Validity should be more than 1 month as on today.',
        ],
      },
    ],
  },
  {
    heading: 'Voter ID',
    subHeading: 'Below are the upload guidelines for Voter ID front & back',
    card: [
      {
        title: 'front',
        docType: 'Voter ID',
        correctImg: 'VoterFrontCorrect',
        wrongImg: 'VoterFrontWrong',
        tips: [
          'Capture the front side of the Voter ID.',
          'Ensure your photo in the document is clear.',
        ],
      },
      {
        title: 'back',
        docType: 'Voter ID',
        correctImg: 'VoterBackCorrect',
        wrongImg: 'VoterBackWrong',
        tips: [
          'Capture the back side of the Voter ID.',
          'Ensure your address in the document is clear.',
        ],
      },
    ],
  },
  {
    heading: 'Driving Licence',
    subHeading:
      'Below are the upload guidelines for Driving Licence front & back',
    card: [
      {
        title: 'front',
        docType: 'Driving Licence',
        correctImg: 'DrivingLicenceFrontCorrect',
        wrongImg: 'DrivingLicenceFrontWrong',
        tips: [
          'Capture the front side of the Driving Licence.',
          'Ensure your photo in the document is clear.',
          'Validity should be more than 1 month as on today.',
        ],
      },
      {
        title: 'back',
        docType: 'Driving Licence',
        correctImg: 'DrivingLicenceBackCorrect',
        wrongImg: 'DrivingLicenceBackWrong',
        tips: [
          'Capture the back side of the Driving Licence.',
          'Ensure address in the document is clear and readable.',
          'Ensure your photo (if there) in the document is clear.',
          'Validity should be more than 1 month as on today.',
        ],
      },
    ],
  },
];

export default Data;
